import React, { useState, useEffect } from 'react';
import { Row, Col } from 'antd';
import './ResponsiveIDEPhaserLayout.css';

interface ResponsiveIDEPhaserLayoutProps {
    ideComponent: React.ReactNode;
    phaserComponent: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

const ResponsiveIDEPhaserLayout: React.FC<ResponsiveIDEPhaserLayoutProps> = ({
    ideComponent,
    phaserComponent,
    className,
    style
}) => {
    const [isMobile, setIsMobile] = useState(false);
    const [isTablet, setIsTablet] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            const width = window.innerWidth;
            setIsMobile(width < 768);
            setIsTablet(width >= 768 && width < 1024);
        };

        // Check on mount
        checkScreenSize();

        // Add event listener for window resize
        window.addEventListener('resize', checkScreenSize);

        // Cleanup
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // Mobile and tablet: Stack vertically (IDE on top, Phaser below)
    if (isMobile || isTablet) {
        return (
            <div 
                className={`responsive-ide-phaser-container ${className || ''}`} 
                style={{ ...style, height: '100%' }}
            >
                {/* IDE Section - Top */}
                <div className="responsive-ide-section ide">
                    {ideComponent}
                </div>
                
                {/* Phaser Section - Bottom */}
                <div className="responsive-ide-section phaser">
                    <div className="phaser-wrapper">
                        {phaserComponent}
                    </div>
                </div>
            </div>
        );
    }

    // Desktop: Side by side layout
    return (
        <div 
            className={`responsive-ide-phaser-container desktop ${className || ''}`} 
            style={{ height: '100%', ...style }}
        >
            <Row gutter={24} style={{ height: '100%', width: '100%' }}>
                <Col span={16} style={{ height: '100%' }}>
                    <div className="responsive-ide-section ide">
                        {ideComponent}
                    </div>
                </Col>
                <Col span={8} style={{ height: '100%' }}>
                    <div className="responsive-ide-section phaser">
                        <div className="phaser-wrapper">
                            {phaserComponent}
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default ResponsiveIDEPhaserLayout;
